/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import {UPLOAD_PAYMENT_RECEIPT  } from "../pages/ApplicationStatus/graphql";
import { toast } from "react-hot-toast"

const MODULE_NAME = "UploadPaymentService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class UploadPaymentService {
    private static instance: UploadPaymentService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): UploadPaymentService {
        if (!UploadPaymentService.instance) {
            UploadPaymentService.instance = new UploadPaymentService(props);
        }
        return UploadPaymentService.instance;
    }

    async  uploadPaymentReceipt(props:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('UploadPaymentService()::uploadPayment()-> entered here..');
        console.log('UploadPaymentService()::uploadPayment()-> entered here..',props);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPLOAD_PAYMENT_RECEIPT,
                    variables: props,

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "uploadPaymentReceipt : ", res?.data)
                console.log('UploadPaymentService()::uploadPayment()-> entered here..',res?.data);
                if (res) {
                    return res?.data?.uploadPaymentReceipt;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
